import React from 'react'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { useStyles } from '../CoachesSearch.styles'

export const COACH_DIRECTORY_HEADING = 'Find golf coaches nearby'

function DirectoryPageHero() {
  const classes = useStyles()

  return (
    <Box className={classes.directoryPageHero}>
      <Box className={classes.directoryPageHeroText}>
        <Typography
          variant="h4"
          component="h1"
          className={classes.directoryHeading}
        >
          {COACH_DIRECTORY_HEADING}
        </Typography>
      </Box>
    </Box>
  )
}

export default DirectoryPageHero
